import { render, staticRenderFns } from "./OtherAssurance.vue?vue&type=template&id=6eb98367&scoped=true"
import script from "./OtherAssurance.vue?vue&type=script&lang=js"
export * from "./OtherAssurance.vue?vue&type=script&lang=js"
import style0 from "./OtherAssurance.vue?vue&type=style&index=0&id=6eb98367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb98367",
  null
  
)

export default component.exports